import React, { useCallback, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  FaVolumeUp,
  FaDownload,
  FaTrash,
  FaSearch,
  FaPlus,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import styles from "./ManageClip.module.css";

const TTSClipApproveStatus = () => {
  const [showRouteDropdown, setShowRouteDropdown] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [assignedRoute, setAssignedRoute] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [clipToReject, setClipToReject] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [clipToApprove, setClipToApprove] = useState(null);
  const [clipData, setClipData] = useState([]);
  const [route, setRoute] = useState(null);
  const [userRouteMap, setUserRouteMap] = useState({});
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [retrUserId, setRetrUserId] = useState(null);
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);


  const loginData = JSON.parse(localStorage.getItem("admin"));
  const user_id = loginData?.user?.userId;
  const token = loginData?.token;

  const { clipId } = useParams();


  const getRouteDetails = useCallback(() => {
    fetch(`${HOST_URL}/route.php?user_id=${user_id}&method=retrieve&token=${token}&type=admin`)
      .then((response) => response.json())
      .then((result) => {
        if (result.success === true) {
          // Filter only 'voice' routes
          const voiceRoutes = result.data.filter(route => route.channel === "voice");

          // Optionally map to a cleaner format
          const formattedRoutes = voiceRoutes.map(route => ({
            id: route.id,
            name: route.route_name
          }));

          setRoute(formattedRoutes); // Update state with only 'voice' routes
        }
      });
  }, [user_id, token]);


  useEffect(() => {
    getRouteDetails();
    if (clipId) {
      setSearchText(clipId);
    }
  }, [getRouteDetails]);

  const fetchRetrUserIdAndClipStatus = async (clipId) => {
    try {
      const payload = {
        user_id,
        token,
        method: "fetch_tts_clip",
      };

      const response = await axios.post(
        `${NODE_HOST_URL_v1}/admin/clipGroup`,
        payload
      );

      if (response.data.success && response.data.tts_clip) {
        const matchedClip = response.data.tts_clip.find(
          (clip) => clip.id.toString() === clipId.toString()
        );

        if (matchedClip) {
          const retr_user_id = matchedClip.user_id;
          setRetrUserId(retr_user_id); // ✅ Store it globally
          await fetchRouteWiseStatus(retr_user_id, clipId);
        }
        else {
          console.warn("Clip ID not found in tts_clip response");
          setClipData([]); // clear table if no match
        }
      } else {
        console.error("Failed to fetch TTS clips");
      }
    } catch (error) {
      console.error("Error fetching retr_user_id:", error);
    }
  };

  const fetchRouteWiseStatus = async (retr_user_id, clip_id) => {
    try {
      const payload = {
        user_id,
        token,
        method: "route_wise_status",
        retr_user_id,
        clip_id,
      };

      const response = await axios.post(
        `${NODE_HOST_URL_v1}/admin/clipGroup`,
        payload
      );
      console.log("Refetched clipData after route assignment:", response.data);

      if (response.data.success && response.data.data) {
        // setClipData(response.data.data); 
        const updatedData = response.data.data.map(item => ({
          ...item,
          retr_user_id: retr_user_id, // add retr_user_id to each row
        }));
        setClipData(updatedData);

      } else {
        console.warn("No clip status data returned");
        setClipData([]);
      }
    } catch (err) {
      console.error("Error fetching route-wise status:", err);
    }
  };

  useEffect(() => {
    getRouteDetails();

    if (clipId) {
      setSearchText(clipId);
      fetchRetrUserIdAndClipStatus(clipId);
    }
  }, [clipId, getRouteDetails]);


  const handleAssignRoute = async () => {
    if (!retrUserId) {
      alert("retr_user_id not available.");
      return;
    }

    if (!selectedRoute) {
      alert("Please select a route.");
      return;
    }

    try {
      const payload = {
        user_id,
        token,
        method: "addNewRoute",
        retr_user_id: retrUserId,
        clipid: clipId.toString(),
        routeid: selectedRoute,
      };

      const { data } = await axios.post(
        `${NODE_HOST_URL_v1}/admin/addNewRoute`,
        payload
      );

      if (data.success) {
        alert("Route assigned successfully.");
        setSelectedRoute("");
        await fetchRouteWiseStatus(retrUserId, clipId); // Refresh to show new assignment
      } else {
        alert(`Failed to assign route: ${data.message}`);
      }
    } catch (err) {
      console.error("Error assigning route:", err);
      alert("Something went wrong during route assignment.");
    }
  };



  const handlePlay = (row) => {
    const audio = new Audio(`https://db2.authkey.io/${row.filePath}`);
    audio.play();
    setShowPlayModal(true);
  };

  const handleDownload = (row) => {
    const link = document.createElement("a");
    link.href = `https://db2.authkey.io/${row.filePath}`;
    link.download = row.audioName;
    link.click();
  };

  const approveClip = async (clip) => {
    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/admin/AdminVoiceApprove`, {
        user_id,
        token,
        method: "adminApprove",
        clipid: clip.clip_id,
        retr_user_id: clip.retr_user_id,
        routeid: clip.route_id,
      });

      if (res.data.success) {
        setMessage(res.data.message);
        fetchRouteWiseStatus(clip.retr_user_id, clip.clip_id);
        console.log("Updated clipData after approval:", clipData);
        // await fetchRetrUserIdAndClipStatus(clipId);

      } else {
        setMessage(res.data.message);
      }
    } catch (err) {
      setMessage("Error approving clip.");
      console.error(err);
    }
  };

  const rejectClip = async (clip) => {
    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/admin/AdminVoiceReject`, {
        user_id,
        token,
        method: "admin_voice_reject",
        clip_id: clip.clip_id,
        retr_user_id: clip.retr_user_id,
        route_id: clip.route_id,
      });

      if (res.data.success) {
        setMessage(res.data.message);
        fetchRouteWiseStatus(clip.retr_user_id, clip.clip_id);
      } else {
        setMessage(res.data.message);
      }
    } catch (err) {
      setMessage("Error rejecting clip.");
      console.error(err);
    }
  };


  // const confirmReject = () => {
  //   alert(`Rejected clip: ${clipToReject.audioName}`);
  //   setShowRejectModal(false);
  //   setClipToReject(null);
  // };

  // const confirmApprove = () => {
  //   alert(`Approved clip: ${clipToApprove.audioName}`);
  //   setShowApproveModal(false);
  //   setClipToApprove(null);
  // };

  const confirmApprove = async () => {
    if (!clipToApprove) return;

    await approveClip(clipToApprove);
    setShowApproveModal(false);
    setClipToApprove(null);
  };

  const confirmReject = async () => {
    if (!clipToReject) return;

    await rejectClip(clipToReject);
    setShowRejectModal(false);
    setClipToReject(null);
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const TTS_CLIP_COLUMNS = [
    { name: "Clip ID", selector: (row) => row.clip_id, sortable: true },
    { name: "Voice ID", selector: (row) => row.voice_id, sortable: true, width: "200px" },
    { name: "Route Name",
      //  selector: (row) => row.route_id, 
      selector: (row) => {
      const matchedRoute = route?.find((r) => r.id === row.route_id);
      return matchedRoute ? matchedRoute.name : row.route_id;
    },
       width: "200px",
       sortable: true },
    {
      name: "Status",
      selector: (row) => {
        const status = row.voice_approve_status;
        const statusText =
          status === 1 ? "Approved" : status === 2 ? "Rejected" : "Pending";
        const statusColor =
          status === 1
            ? "green"
            : status === 2
              ? "red"
              : "orange";

        return (
          <span style={{ color: statusColor, fontWeight: "bold" }}>
            {statusText}
          </span>
        );
      },
      sortable: true,
    },
    {
      name: "Updated Date",
      selector: (row) => new Date(row.updated_date).toLocaleString(),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <FaVolumeUp
            style={{ cursor: "pointer", color: "#17a2b8", marginRight: "8px" }}
            onClick={() =>
              handlePlay({ filePath: row.file_path })
            }
            title="Play"
          />
          <FaDownload
            style={{ cursor: "pointer", color: "#28a745" }}
            onClick={() =>
              handleDownload({
                filePath: row.file_path,
                fileName: row.voice_id + ".mp3",
              })
            }
            title="Download"
          />
          {row.voice_approve_status !== 1 && (
            <button
              // onClick={() => approveClip(row)}
              onClick={() => {
                setClipToApprove(row);
                setShowApproveModal(true);
              }}

              style={{
                backgroundColor: "#e9fce9",
                color: "#0b6e35",
                padding: "2px 2px",
                borderRadius: "4px",

                fontWeight: 500,
                fontSize: "12px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Approve
            </button>
          )}

          {row.voice_approve_status !== 2 && (
            <button
              // onClick={() => rejectClip(row)}
              onClick={() => {
                setClipToReject(row);
                setShowRejectModal(true);
              }}

              style={{
                backgroundColor: "#ffe6e6",
                color: "#b30000",
                padding: "2px 2px",

                borderRadius: "4px",
                fontWeight: 500,
                fontSize: "12px",
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              Reject
            </button>
          )}

        </div>

      ),
      ignoreRowClick: true,
      width: "350px",
    },

  ];



  return (
    <div className="wrapper">
      <AdminLeftMenu />
      <div className="main">
        <AdminHeader />
        <main className="content p-4">
          <h4 className={styles.manageClipHeading}>TTS Clip Approve Status</h4>

          {message && (
            <div
              style={{
                position: "fixed",
                top: "20px",
                right: "20px",
                background: "#fff",
                color: "#333",
                padding: "12px 16px",
                borderRadius: "8px",
                boxShadow: "0 0 10px rgba(0,0,0,0.15)",
                zIndex: 9999,
              }}
            >
              {message}
              <button
                style={{ marginLeft: "12px", background: "none", border: "none", cursor: "pointer" }}
                onClick={() => setMessage("")}
              >
                ✖
              </button>
            </div>
          )}


          <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
            {/* Input field */}
            <input
              type="text"
              className="form-control"
              style={{ maxWidth: "300px", height: "38px" }}
              placeholder="Enter Voice ID..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            {/* Search button */}
            <button
              className="btn btn-success d-flex align-items-center gap-2 px-3"
              style={{
                height: "38px",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                marginLeft: "8px",
              }}
            // onClick={handleSearch}
            >
              <FaSearch size={14} />
              <span>Search</span>
            </button>
          </div>
          <div className="mb-3">
            <button
              className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
              onClick={() => setShowRouteDropdown(true)}
            >
              <FaPlus /> Add new Route for this voice
            </button>
          </div>

          {showRouteDropdown && (
            <div className="row g-2 align-items-center mb-4">
              <div className="col-md-4">
                <select
                  className="form-select form-select-sm"
                  value={selectedRoute}
                  onChange={(e) => setSelectedRoute(e.target.value)}
                  style={{ height: "34px" }}
                >
                  <option value="">-- Select Route --</option>
                  {route.map((route) => (
                    <option key={route.id} value={route.id}>
                      {route.name}
                    </option>
                  ))}
                </select>

              </div>
              {selectedRoute && (
                <div className="col-auto">
                  <button
                    className="btn btn-sm btn-success d-flex align-items-center gap-2"
                    style={{ height: "34px", padding: "4px 16px" }}
                    // disabled={!selectedRoute || selectedRows.length === 0}
                    onClick={handleAssignRoute}
                  >
                    Assign Route
                  </button>
                </div>
              )}
            </div>
          )}

          <AdvanceDataTable
            tableCell={TTS_CLIP_COLUMNS}
            tableData={clipData}
            // selectable={true}
            isLoading={loading}
          // onRowSelect={(selectedRows) => setSelectedRows(selectedRows)}
          />


          {showRejectModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "8px",
                  width: "400px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                }}
              >
                <h5>Confirm Reject</h5>
                <p>
                  Are you sure you want to reject clip <strong>{clipToReject?.audioName}</strong>?
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button className="btn btn-danger btn-sm" onClick={confirmReject}>
                    Reject
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {showApproveModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "8px",
                  width: "400px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                }}
              >
                <h5>Confirm Approve</h5>
                <p>
                  Are you sure you want to approve clip <strong>{clipToApprove?.audioName}</strong>?
                </p>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button className="btn btn-success btn-sm" onClick={confirmApprove}>
                    Approve
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setShowApproveModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {showPlayModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "400px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                }}
              >
                <h5>Play Audio</h5>
                <audio
                  controls
                  autoPlay
                  src={audioUrl}
                  style={{ width: "100%" }}
                />
                <div className="text-end mt-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPlayModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
        <AdminFooter />
      </div>
    </div>
  );
};

export default TTSClipApproveStatus;
